module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #logoutApi":{"httpMethod":[{"value":"post","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root #logoutApi","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/options/root/logoutApi.js
// module id = 220
// module chunks = 2